import axios from "axios";
import { MessageBox, Message, Loading } from "element-ui";
import store from "@/store";
import { base64Encode } from "@/utils/common";
import qs from "qs";

// // create an axios instance
// const service = axios.create({
//   baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
//   // withCredentials: true, // send cookies when cross-domain requests
//   timeout: 5000 // request timeout
// })

// // request interceptor
// service.interceptors.request.use(
//   config => {
//     // do something before request is sent

//     if (store.getters.token) {
//       // let each request carry token
//       // ['X-Token'] is a custom headers key
//       // please modify it according to the actual situation
//       config.headers['X-Token'] = getToken()
//     }
//     return config
//   },
//   error => {
//     // do something with request error
//     return Promise.reject(error)
//   }
// )

// // response interceptor
// service.interceptors.response.use(
//   /**
//    * If you want to get http information such as headers or status
//    * Please return  response => response
//   */

//   /**
//    * Determine the request status by custom code
//    * Here is just an example
//    * You can also judge the status by HTTP Status Code
//    */
//   response => {
//     const res = response.data

//     // if the custom code is not 20000, it is judged as an error.
//     if (res.code !== 20000) {
//       Message({
//         message: res.message || 'Error',
//         type: 'error',
//         duration: 5 * 1000
//       })

//       // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
//       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//         // to re-login
//         MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
//           confirmButtonText: 'Re-Login',
//           cancelButtonText: 'Cancel',
//           type: 'warning'
//         }).then(() => {
//           store.dispatch('user/resetToken').then(() => {
//             location.reload()
//           })
//         })
//       }
//       return Promise.reject(new Error(res.message || 'Error'))
//     } else {
//       return res
//     }
//   },
//   error => {
//     Message({
//       message: error.message,
//       type: 'error',
//       duration: 5 * 1000
//     })
//     return Promise.reject(error)
//   }
// )

const baseURL = "/ftdi";
// const baseURL = "http://10.110.193.232:1002/ftdi"

export const request = (reuqestUrl, params, options) => {
  const au = store.getters.au;
  const url = `${baseURL}${reuqestUrl}`;
  const data = params instanceof FormData ? params : qs.stringify(params);
  let userInfo = {
    userId: store.getters.userId,
    userName: store.getters.userName,
    loginName: store.getters.loginName,
  };
  const user = base64Encode(JSON.stringify(userInfo));
  return axios({
    method: "post",
    url,
    data,
    headers: {
      au: au,
      user: user,
    },
    ...options,
  }).then(
    (response) => {
      if (response.headers["content-type"].indexOf("excel") >= 0) {
        return response;
      }
      const resp = response.data;
      if (
        url === "/ftdi/sysFile/download" ||
        url === "/ftdi/question/export/userQuestionnaire" ||
        url === "/ftdi/question/export/exportAll" ||
        url === "/ftdi/question/user/question/export"
      ) {
        return response;
      }
      // debugger
      // if( reuqestUrl == '/access/add' ) {
      //   return resp;
      // }
      if (resp.code === 0) {
        return resp;
      }
      if (resp.code === 1002) {
        return resp;
      }
      if (resp.code === 1000) {
        Loading.service({ fullscreen: true, body: true });
        store.dispatch("user/logout");
        location.reload();
        return Promise.reject(Error("已退出登录"));
        /* MessageBox.alert('您已退出, 请重新登录', '确认退出', {
        confirmButtonText: '重新登录',
        type: 'warning',
        showClose: false
      }).then(() => {
        Loading.service({ fullscreen: true, body: true })
        store.dispatch('user/logout')
        location.reload()
      })
      return Promise.reject(Error('已退出登录')) */
      }
      Message({
        message: resp.msg || "服务器繁忙",
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject(resp.msg);
    },
    (error) => {
      console.error(`上行:${url}:`, params, error);
      Message({
        message: "服务器繁忙!",
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject(error);
    }
  );
};

export const requestLoading = (reuqestUrl, data, options) => {
  const loading = Loading.service({ fullscreen: true });
  return request(reuqestUrl, data, options).finally(() => {
    loading.close();
  });
};

export const get = (url) => (params, options) =>
  requestLoading(url, params, options).then((resp) => resp.data);

export const post = (url) => (params, options) =>
  requestLoading(url, params, options).then((resp) => {
    Message({
      message: resp.msg || "操作成功",
      type: resp.code == 1002 ? "error" : "success",
      duration: 2 * 1000,
    });
    if (resp.code === 1002) {
      return resp;
    } else {
      return resp.data;
    }
  });

export const postMsg = (url) => (params, options) =>
  requestLoading(url, params, options).then((resp) => {
    return resp;
  });
export default get;
